/* Tea Lab article page: copies the article link when the copy button is pressed and tells screen readers it worked. */
(function () {
  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      var t = document.createElement('textarea');
      t.value = text;
      t.setAttribute('readonly', '');
      t.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0';
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy') ? resolve() : reject(new Error('copy failed')); } catch (err) { reject(err); }
      document.body.removeChild(t);
    });
  }
  function setup(btn) {
    if (btn.__tla) return;
    btn.__tla = true;
    var live = btn.parentNode.querySelector('[data-tla-live]');
    var timer;
    btn.addEventListener('click', function () {
      copyText(btn.getAttribute('data-url') || window.location.href).then(function () {
        btn.setAttribute('data-copied', '');
        if (live) live.textContent = btn.getAttribute('data-copied-label') || '';
        clearTimeout(timer);
        timer = setTimeout(function () {
          btn.removeAttribute('data-copied');
          if (live) live.textContent = '';
        }, 2400);
      }, function () {});
    });
  }
  function init(root) {
    (root || document).querySelectorAll('[data-tla-copy]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Tea Lab article page: scroll reveal for the blocks of an article's own layout (photos, quotes, steps, FAQ ...).
   Only blocks that start below the first screen are hidden, and only by this script, so nothing stays hidden if it does not run. */
(function () {
  var mode = document.documentElement.getAttribute('data-tl-motion') || 'subtle';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (mode === 'off' || reduce || !('IntersectionObserver' in window)) return;
  if (window.Shopify && window.Shopify.designMode) return;
  var SEL = '.tl-blog .tl-figure, .tl-blog .tl-pull, .tl-blog .tl-feature, .tl-blog .tl-table-wrap, .tl-blog .tl-collection-card, .tl-blog .tl-step, .tl-blog .tl-faq details, .tl-blog .tl-bottom, .tl-blog h2, .tl-blog h3';
  function start() {
    var host = document.querySelector('.tla__content');
    if (!host) return;
    var vh = window.innerHeight || 800;
    var list = Array.prototype.filter.call(host.querySelectorAll(SEL), function (el) {
      if (/^H[23]$/.test(el.tagName) && el.closest('.tl-feature, .tl-bottom')) return false;
      return el.getBoundingClientRect().top > vh * 0.92;
    });
    if (!list.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting && e.boundingClientRect.top >= 0) return;
        e.target.classList.add('tla-r-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
    list.forEach(function (el) {
      var sib = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : 0;
      el.style.setProperty('--tla-i', /tl-collection-card|tl-step/.test(el.className) || el.tagName === 'DETAILS' ? Math.min(sib, 5) : 0);
      el.classList.add('tla-r');
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Tea Lab article page: thin gold reading line, and a contents list built from the article's own headings.
   Headings keep any id the article already has; the others get one, so every section can be linked to. */
(function () {
  var onScroll = null;
  var io = null;
  function slug(text) {
    return text.toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
  }
  function init() {
    var host = document.querySelector('.tla__content');
    if (!host) return;
    var bar = document.querySelector('[data-tla-progress]');
    if (onScroll) { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); onScroll = null; }
    if (bar) {
      var queued = false;
      var paint = function () {
        queued = false;
        var r = host.getBoundingClientRect();
        var vh = window.innerHeight || 800;
        var total = r.height - vh * 0.5;
        var p = total > 0 ? Math.min(1, Math.max(0, (vh * 0.15 - r.top) / total)) : 0;
        bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      };
      onScroll = function () { if (!queued) { queued = true; requestAnimationFrame(paint); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      paint();
    }
    var toc = document.querySelector('[data-tla-toc]');
    if (!toc) return;
    var min = parseInt(toc.getAttribute('data-min'), 10) || 3;
    var heads = Array.prototype.filter.call(host.querySelectorAll('h2'), function (h) {
      return h.textContent.trim() && !h.closest('.tl-blog, .tla-product, details');
    });
    if (heads.length < min) return;
    var list = toc.querySelector('.tla-toc__l');
    if (!list) return;
    list.innerHTML = '';
    var links = [];
    heads.forEach(function (h) {
      var id = h.id;
      if (!id) {
        var base = slug(h.textContent);
        var n = 2;
        id = base;
        while (document.getElementById(id)) { id = base + '-' + n; n += 1; }
        h.id = id;
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
      links.push({ a: a, h: h });
    });
    toc.hidden = false;
    if (window.innerWidth < 700) toc.removeAttribute('open');
    if (io) { io.disconnect(); io = null; }
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (l) { l.a.classList.toggle('is-active', l.h === e.target); });
        });
      }, { rootMargin: '-18% 0px -72% 0px' });
      heads.forEach(function (h) { io.observe(h); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
